import { render, staticRenderFns } from "./newInvitationDetail.vue?vue&type=template&id=1de3abd2&scoped=true&"
import script from "./newInvitationDetail.vue?vue&type=script&lang=js&"
export * from "./newInvitationDetail.vue?vue&type=script&lang=js&"
import style0 from "./newInvitationDetail.vue?vue&type=style&index=0&id=1de3abd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3abd2",
  null
  
)

export default component.exports